'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _templateObject = _taggedTemplateLiteral(['\n  font-size: 10px;\n  height: 18px;\n  padding: 0px 8px;\n  border-radius: 9px;\n  ', ';\n'], ['\n  font-size: 10px;\n  height: 18px;\n  padding: 0px 8px;\n  border-radius: 9px;\n  ', ';\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n          width: 18px;\n          border-radius: 50%;\n          padding: 0px;\n        '], ['\n          width: 18px;\n          border-radius: 50%;\n          padding: 0px;\n        ']),
    _templateObject3 = _taggedTemplateLiteral(['\n  font-size: 12px;\n  height: 24px;\n  padding: 0px 10px;\n  border-radius: 12px;\n  ', ';\n'], ['\n  font-size: 12px;\n  height: 24px;\n  padding: 0px 10px;\n  border-radius: 12px;\n  ', ';\n']),
    _templateObject4 = _taggedTemplateLiteral(['\n          width: 24px;\n          border-radius: 50%;\n          padding: 0px;\n        '], ['\n          width: 24px;\n          border-radius: 50%;\n          padding: 0px;\n        ']),
    _templateObject5 = _taggedTemplateLiteral(['\n  font-size: 12px;\n  height: 32px;\n  padding: 0px 20px;\n  border-radius: 16px;\n  ', ';\n'], ['\n  font-size: 12px;\n  height: 32px;\n  padding: 0px 20px;\n  border-radius: 16px;\n  ', ';\n']),
    _templateObject6 = _taggedTemplateLiteral(['\n          width: 32px;\n          border-radius: 50%;\n          padding: 0px;\n        '], ['\n          width: 32px;\n          border-radius: 50%;\n          padding: 0px;\n        ']),
    _templateObject7 = _taggedTemplateLiteral(['\n  font-size: 14px;\n  height: 40px;\n  padding: 0px 30px;\n  border-radius: 20px;\n  ', ';\n'], ['\n  font-size: 14px;\n  height: 40px;\n  padding: 0px 30px;\n  border-radius: 20px;\n  ', ';\n']),
    _templateObject8 = _taggedTemplateLiteral(['\n          width: 40px;\n          border-radius: 50%;\n          padding: 0px;\n        '], ['\n          width: 40px;\n          border-radius: 50%;\n          padding: 0px;\n        ']),
    _templateObject9 = _taggedTemplateLiteral(['\n  font-size: 24px;\n  height: 60px;\n  padding: 0px 45px;\n  border-radius: 60px;\n  ', ';\n'], ['\n  font-size: 24px;\n  height: 60px;\n  padding: 0px 45px;\n  border-radius: 60px;\n  ', ';\n']),
    _templateObject10 = _taggedTemplateLiteral(['\n          width: 60px;\n          border-radius: 50%;\n          padding: 0px;\n        '], ['\n          width: 60px;\n          border-radius: 50%;\n          padding: 0px;\n        ']),
    _templateObject11 = _taggedTemplateLiteral(['\n        background: ', ';\n        color: ', ';\n      '], ['\n        background: ', ';\n        color: ', ';\n      ']),
    _templateObject12 = _taggedTemplateLiteral(['\n        border-color: ', ';\n        color: ', ';\n      '], ['\n        border-color: ', ';\n        color: ', ';\n      ']),
    _templateObject13 = _taggedTemplateLiteral(['\n  background: transparent;\n  font-family: ProximaNova;\n  font-weight: 700;\n  color: ', ';\n  text-transform: uppercase;\n  margin: 0px;\n  border-style: solid;\n  border-width: 2px;\n  border-color: transparent;\n  cursor: pointer;\n  user-select: none;\n  white-space: nowrap;\n  box-shadow: ', ';\n  ', ';\n  ', ';\n  ', ';\n  ', ';\n  ', ';\n  ', ';\n  ', ';\n'], ['\n  background: transparent;\n  font-family: ProximaNova;\n  font-weight: 700;\n  color: ', ';\n  text-transform: uppercase;\n  margin: 0px;\n  border-style: solid;\n  border-width: 2px;\n  border-color: transparent;\n  cursor: pointer;\n  user-select: none;\n  white-space: nowrap;\n  box-shadow: ', ';\n  ', ';\n  ', ';\n  ', ';\n  ', ';\n  ', ';\n  ', ';\n  ', ';\n']),
    _templateObject14 = _taggedTemplateLiteral(['\n          opacity: 0.5;\n          cursor: not-allowed;\n        '], ['\n          opacity: 0.5;\n          cursor: not-allowed;\n        ']),
    _templateObject15 = _taggedTemplateLiteral(['\n          cursor: not-allowed;\n        '], ['\n          cursor: not-allowed;\n        ']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _colors = require('../../libs/colors');

var colors = _interopRequireWildcard(_colors);

var _Icon = require('./Icon.Button');

var _Icon2 = _interopRequireDefault(_Icon);

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _taggedTemplateLiteral(strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
} // Colors
// Components


var tinySize = (0, _styledComponents.css)(_templateObject, function (_ref) {
  var circular = _ref.circular;
  return circular ? (0, _styledComponents.css)(_templateObject2) : '';
});
var smallSize = (0, _styledComponents.css)(_templateObject3, function (_ref2) {
  var circular = _ref2.circular;
  return circular ? (0, _styledComponents.css)(_templateObject4) : '';
});
var normalSize = (0, _styledComponents.css)(_templateObject5, function (_ref3) {
  var circular = _ref3.circular;
  return circular ? (0, _styledComponents.css)(_templateObject6) : '';
});
var largeSize = (0, _styledComponents.css)(_templateObject7, function (_ref4) {
  var circular = _ref4.circular;
  return circular ? (0, _styledComponents.css)(_templateObject8) : '';
});
var giantSize = (0, _styledComponents.css)(_templateObject9, function (_ref5) {
  var circular = _ref5.circular;
  return circular ? (0, _styledComponents.css)(_templateObject10) : '';
});
var sizes = {
  tiny: tinySize,
  small: smallSize,
  normal: normalSize,
  large: largeSize,
  giant: giantSize
};
var themes = {
  full: Object.keys(colors).reduce(function (combined, key) {
    return _extends({}, combined, _defineProperty({}, key, (0, _styledComponents.css)(_templateObject11, colors[key], key === 'grey' ? colors.darkGrey : colors.white)));
  }, {}),
  outline: Object.keys(colors).reduce(function (combined, key) {
    return _extends({}, combined, _defineProperty({}, key, (0, _styledComponents.css)(_templateObject12, colors[key], key === 'grey' ? colors.darkGrey : colors[key])));
  }, {})
};

var StyledButton = _styledComponents2.default.button(_templateObject13, colors.white, function (_ref6) {
  var shadow = _ref6.shadow;
  return !shadow ? 'none' : '0 2px 20px 0 rgba(0, 0, 0, 0.1)';
}, function (_ref7) {
  var size = _ref7.size;
  return sizes[size];
}, function (_ref8) {
  var theme = _ref8.theme,
      outline = _ref8.outline;
  return themes[outline ? 'outline' : 'full'][theme];
}, function (_ref9) {
  var circular = _ref9.circular;
  return circular ? 'border-radius: 50%;' : '';
}, function (_ref10) {
  var block = _ref10.block;
  return block ? 'display: block; width: 100%;' : '';
}, function (_ref11) {
  var red = _ref11.red,
      black = _ref11.black;
  if (black) return 'color: ' + colors.black + ';';
  if (red) return 'color: ' + colors.red + ';';
  return '';
}, function (_ref12) {
  var disabled = _ref12.disabled;
  return disabled ? (0, _styledComponents.css)(_templateObject14) : '';
}, function (_ref13) {
  var loading = _ref13.loading;
  return loading ? (0, _styledComponents.css)(_templateObject15) : '';
});

var Button = function Button(_ref14) {
  var icon = _ref14.icon,
      size = _ref14.size,
      disabled = _ref14.disabled,
      loading = _ref14.loading,
      outline = _ref14.outline,
      theme = _ref14.theme,
      children = _ref14.children,
      _onClick = _ref14.onClick,
      block = _ref14.block,
      shadow = _ref14.shadow,
      red = _ref14.red,
      black = _ref14.black,
      props = _objectWithoutProperties(_ref14, ['icon', 'size', 'disabled', 'loading', 'outline', 'theme', 'children', 'onClick', 'block', 'shadow', 'red', 'black']);

  return _react2.default.createElement(StyledButton, _extends({
    size: size,
    disabled: disabled,
    loading: loading,
    outline: outline,
    theme: theme,
    onClick: function onClick(e) {
      return !disabled && !loading && _onClick(e);
    },
    circular: !children,
    block: block,
    shadow: shadow,
    red: red,
    black: black
  }, props), icon !== null && !loading && _react2.default.createElement(_Icon2.default, {
    notransform: size === 'tiny' ? 1 : 0,
    margin: children !== null ? 1 : 0,
    icon: icon
  }), loading && _react2.default.createElement(_Icon2.default, {
    notransform: size === 'tiny' ? 1 : 0,
    margin: children !== null ? 1 : 0,
    icon: 'loading2',
    spin: true
  }), children);
};

Button.propTypes = {
  icon: _propTypes2.default.string,
  size: _propTypes2.default.oneOf(['tiny', 'small', 'normal', 'large', 'giant']),
  disabled: _propTypes2.default.bool,
  loading: _propTypes2.default.bool,
  outline: _propTypes2.default.bool,
  theme: _propTypes2.default.oneOf(Object.keys(colors)),
  block: _propTypes2.default.bool,
  shadow: _propTypes2.default.bool,
  red: _propTypes2.default.bool,
  black: _propTypes2.default.bool,
  children: _propTypes2.default.node,
  onClick: _propTypes2.default.func
};
Button.defaultProps = {
  icon: null,
  size: 'normal',
  disabled: false,
  loading: false,
  outline: false,
  theme: 'red',
  block: false,
  shadow: false,
  red: false,
  black: false,
  children: null,
  onClick: function onClick() {
    return null;
  }
};
exports.default = Button;